export const VIEW_PAGE_LUNA_AI_DESIGN = "view_page_luna_ai_design";
